import {
  FormControl,
  InputLabel,
  LinearProgress,
  MenuItem,
  Pagination,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
} from "@mui/material";
import moment from "moment";
import { useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { dateFiltersVision } from "../centralOms/common/constants";
import { EVENTS } from "../centralOms/events_constant";
import {
  fetchUserDetailsAndSetUserForAnalytics,
  logEventToAnalyticsPlatform,
} from "../../helper/events";
import ActionsCell from "./actionsCell";
import MoveToPickedDialog from "./dialogs/moveToPicked";
import UploadBillDialog from "./dialogs/uploadBill";
import CartDialog from "./dialogs/cart";
import OrderSummaryDialog from "./dialogs/orderSummary";
import MoveToPickupReadyDialog from "./dialogs/moveToPickupReady";
import ViewRxDialog from "./dialogs/viewRx";

export const TableStructure = ({
  orders,
  totalRows,
  page,
  setPage,
  loading,
  fetchData,
  setFetchData,
  sortDirection,
  setSortDirection,
  setSortLabel,
  tabName,
  applicableActions,
  showPartnerOrderId,
  showSLA,
  rxToShowStatus,
  setNavigateToAll
}) => {
  const dateFilterObject = JSON.parse(
    sessionStorage.getItem("dateFilterObject")
  );
  const dateFilterName = dateFilterObject?.name
    ? dateFilterObject.name
    : "Previous 7 Days";
  const [dateFilter, setDateFilter] = useState(dateFilterName);
  const selectedDateFilter = dateFiltersVision.find(
    (elem) => elem.name === dateFilterName
  );
  const [startDate, setStartDate] = useState(
    dateFilterObject?.startDate
      ? dateFilterObject.startDate
      : selectedDateFilter.startDate
  );
  const [endDate, setEndDate] = useState(
    dateFilterObject?.endDate
      ? dateFilterObject.endDate
      : selectedDateFilter.endDate
  );
  const [currentOrder, setCurrentOrder] = useState(null);
  const [billUploadDialogVisible, setBillUploadDialogVisibility] =
    useState(false);
  const [moveToPickedDialogVisible, setMoveToPickedDialogVisibility] =
    useState(false);
  const [cartDialogVisible, setCartDialogVisibility] = useState(false);
  const [orderSummaryVisible, setOrderSummaryVisibility] = useState(false);
  const [moveToPickupReadyDialogVisible, setMoveToPickupReadyDialogVisibility] =
    useState(false);
  const [viewRxDialogVisible, setViewRxDialogVisibility] = useState(false);
  const user_details = JSON.parse(localStorage.getItem("user_details"));
  const childEntities = user_details?.parentProvider?.isParent ? user_details.parentProvider.childEntities : null;

  useEffect(() => {
    const triggerEvents = async () => {
      await fetchUserDetailsAndSetUserForAnalytics();
      logEventToAnalyticsPlatform({
        name: EVENTS.PC_SCREEN_LANDING.name,
        payload: {
          tab_name: tabName,
          service_type: EVENTS.SERVICE_TYPE_OMS,
          screenName: EVENTS.SERVICE_NAME_VISION,
        },
        schema: EVENTS.PC_SCREEN_LANDING.schema,
      });
    };
    if (tabName) {
      triggerEvents();
    }
  }, []);

  const onDateChange = (selectedValue) => {
    setDateFilter(selectedValue);
    const selectedDateFilter = dateFiltersVision.find(
      (elem) => elem.name === selectedValue
    );
    if (
      selectedDateFilter &&
      selectedDateFilter.startDate &&
      selectedDateFilter.endDate
    ) {
      setStartDate(selectedDateFilter.startDate);
      setEndDate(selectedDateFilter.endDate);
      let dateFilterObject = {
        name: selectedValue,
      };
      sessionStorage.setItem(
        "dateFilterObject",
        JSON.stringify(dateFilterObject)
      );
      setFetchData(!fetchData);
    } else {
      setStartDate("");
      setEndDate("");
    }
  };
  const calculateAge = (dateOfBirth) => {
    if (
      !dateOfBirth ||
      dateOfBirth === "/Date(-62135596800000-0000)/" ||
      dateOfBirth.match("000")
    )
      return "NA";

    const today = new Date();
    const dob = new Date(dateOfBirth);

    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }

    return !Number(age) ? "NA" : age;
  };

  const handleChangePage = (event, newPage) => {
    setFetchData(!fetchData);
    setPage(newPage);
  };

  const handleClickSearch = () => {
    let dateFilterObject = {
      name: dateFilter,
      startDate: startDate,
      endDate: endDate,
    };
    sessionStorage.setItem(
      "dateFilterObject",
      JSON.stringify(dateFilterObject)
    );
    setFetchData(!fetchData);
    logEventToAnalyticsPlatform({
      name: EVENTS.PC_LS_ACTION.name,
      payload: {
        tab_name: tabName,
        filterValue: "true",
        reference_id: "",
        reference_provider_id: "",
        service_name: EVENTS.SERVICE_NAME_VISION,
        action: EVENTS.ACTION.SEARCH_ICON_CLICKED,
      },
      schema: EVENTS.PC_LS_ACTION.schema,
    });
  };

  const handleRequestSort = (sortLabel) => {
    setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    setSortLabel(sortLabel);
    setFetchData(!fetchData);
  };

  const headCells = [
    {
      id: "orderid",
      label: "Order ID",
      sortEnabled: false,
    },
    {
      id: "customerdetails",
      label: "Customer Details",
      sortEnabled: false,
    },
    {
      id: "contactno",
      label: "Contact No.",
      sortEnabled: false,
    },
    {
      id: "createddate",
      label: "Created Date & Time",
      sortEnabled: true,
      sortLabel: "CreationDate",
    }
  ];
  if (showPartnerOrderId) {
    headCells.push({
      id: "partnerorderid",
      label: "Partner Order ID",
      sortEnabled: false,
    });
  }
  if(childEntities) {
    headCells.push({
      id: "providername",
      label: "Provider Name",
      sortEnabled: false,
    });
  }
  headCells.push({
    id: "actions",
    label: "Actions",
  });

  return (
    <>
      <div className="flex w-full justify-between pb-4 px-4">
        <div className="flex date-filter-dashboard">
          <FormControl sx={{ width: 140 }} size="small">
            <InputLabel id="dateFilter">Creation Date</InputLabel>
            <Select
              labelId="dateFilter"
              name="dateFilter"
              id="dateFilter"
              value={dateFilter}
              label="Creation Date"
              onChange={(event) => {
                onDateChange(event.target.value);
              }}
            >
              {dateFiltersVision.map((elem) => (
                <MenuItem value={elem.name}>{elem.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <div className="ml-2">
            <TextField
              className="w-full"
              id="date"
              label="Start Date"
              type="date"
              value={startDate ? startDate : ""}
              onChange={(evt) => setStartDate(evt.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              disabled={dateFilter === "Custom" ? false : true}
            />
          </div>
          <div className="ml-2">
            <TextField
              className="w-full"
              id="date"
              label="End Date"
              type="date"
              value={endDate ? endDate : ""}
              onChange={(evt) => setEndDate(evt.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              disabled={dateFilter === "Custom" ? false : true}
            />
          </div>
          <div className="ml-2 search-icon">
            <div className="w-full">
              <div className="m-auto">
                <SearchIcon onClick={() => handleClickSearch()} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="appointment-wrapper">
        {loading ? <LinearProgress /> : <div className="h-1"></div>}
        <TableContainer>
          <Table
            sx={{ minWidth: 750 }}
            className="text-sm"
            aria-labelledby="tableTitle"
            size={"medium"}
          >
            <TableHead>
              <TableRow className="bg-gray-100">
                {headCells.map((headCell) => (
                  <TableCell key={headCell.id} align="left" padding="normal">
                    {headCell.sortEnabled ? (
                      <TableSortLabel
                        direction={sortDirection}
                        onClick={() => handleRequestSort(headCell.sortLabel)}
                      >
                        <span className="font-bold text-xs">
                          {headCell.label}
                        </span>
                      </TableSortLabel>
                    ) : (
                      <span className="font-bold text-xs">
                        {headCell.label}
                      </span>
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {orders?.length > 0
                ? orders.map((order, index) => {
                    const labelId = `enhanced-table-checkbox-${index}`;
                    return (
                      <TableRow
                        hover
                        tabIndex={-1}
                        key={order.id}
                        className="bg-white"
                      >
                        <TableCell
                          align="left"
                          component="th"
                          id={labelId}
                          scope="row"
                        >
                          <div className="text-gray-500">{order.orderId}</div>
                        </TableCell>
                        <TableCell align="left">
                          <strong>{order.patientName}</strong>
                          <div className="text-gray-500 text-xs">
                            Age: {calculateAge(order.dob ?? "")}
                          </div>
                          <div className="text-gray-500 text-xs">
                            Gender: {order.gender}
                          </div>
                        </TableCell>
                        <TableCell align="left">
                          <div className="text-gray-500 text-xs">
                            {order.phone}
                          </div>
                        </TableCell>
                        <TableCell align="left">
                          <div className="text-xs">
                            {moment(order.createdOn).format("MMMM Do YYYY")}
                            <div className="text-gray-500 text-xs">
                              {moment(order.createdOn).format("hh:mm A")}
                            </div>
                          </div>
                        </TableCell>
                        {showPartnerOrderId && (
                          <TableCell align="left">
                            <div className="text-gray-500">
                              {order.partnerOrderId}
                            </div>
                          </TableCell>
                        )}
                        {childEntities && (
                          <TableCell align="left">
                            <div className="text-xs">{childEntities[order.currentProvider] || order.providerName}</div>
                          </TableCell>
                        )}
                        <TableCell align="left">
                          <ActionsCell
                            applicableActions={applicableActions}
                            currentOrder={order}
                            setMoveToPickedDialogVisibility={
                              setMoveToPickedDialogVisibility
                            }
                            setCartDialogVisibility={setCartDialogVisibility}
                            setBillUploadDialogVisibility={
                              setBillUploadDialogVisibility
                            }
                            setOrderSummaryVisibility={
                              setOrderSummaryVisibility
                            }
                            setCurrentOrder={setCurrentOrder}
                            setMoveToPickupReadyDialogVisibility={
                              setMoveToPickupReadyDialogVisibility
                            }
                            setViewRxDialogVisibility={setViewRxDialogVisibility}
                            showSLA={showSLA}
                            rxToShowStatus={rxToShowStatus}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })
                : null}
            </TableBody>
          </Table>
        </TableContainer>
        <Stack spacing={2} className="p-2">
          <div className="flex justify-between">
            <div className="pt-2">
              {orders?.length > 0 && (
                <div>
                  <span className="text-gray-400 text-sm">Total Counts :</span>
                  <span className="text-gray-400 pl-2 font-semibold text-sm">
                    {totalRows}
                  </span>
                </div>
              )}
            </div>

            <div>
              <Pagination
                count={Math.ceil(totalRows / 10)}
                boundaryCount={4}
                showFirstButton={true}
                showLastButton={true}
                page={page}
                onChange={handleChangePage}
              />
            </div>
          </div>
        </Stack>
      </div>
      {billUploadDialogVisible && (
        <UploadBillDialog
          billUploadDialogVisible={billUploadDialogVisible}
          setBillUploadDialogVisibility={setBillUploadDialogVisibility}
          orderId={currentOrder.orderId}
          patientName={currentOrder.patientName}
          vendorOrderId={currentOrder.partnerOrderId}
          setNavigateToAll={setNavigateToAll}
        ></UploadBillDialog>
      )}
      {moveToPickedDialogVisible && (
        <MoveToPickedDialog
          moveToPickedDialogVisible={moveToPickedDialogVisible}
          orderId={currentOrder.orderId}
          patientName={currentOrder.patientName}
          setMoveToPickedDialogVisibility={setMoveToPickedDialogVisibility}
          setNavigateToAll={setNavigateToAll}
        ></MoveToPickedDialog>
      )}
      {cartDialogVisible && (
        <CartDialog
          cartDialogVisible={cartDialogVisible}
          setCartDialogVisibility={setCartDialogVisibility}
          orderId={currentOrder.orderId}
          patientName={currentOrder.patientName}
          setNavigateToAll={setNavigateToAll}
        ></CartDialog>
      )}
      {orderSummaryVisible && (
        <OrderSummaryDialog
          orderSummaryVisible={orderSummaryVisible}
          setOrderSummaryVisibility={setOrderSummaryVisibility}
          requestId={currentOrder.id}
        ></OrderSummaryDialog>
      )}
      {moveToPickupReadyDialogVisible && (
        <MoveToPickupReadyDialog
          moveToPickupReadyDialogVisible={moveToPickupReadyDialogVisible}
          orderId={currentOrder.orderId}
          patientName={currentOrder.patientName}
          vendorOrderId={currentOrder.partnerOrderId}
          setMoveToPickupReadyDialogVisibility={
            setMoveToPickupReadyDialogVisibility
          }
          setNavigateToAll={setNavigateToAll}
        ></MoveToPickupReadyDialog>
      )}
      {viewRxDialogVisible && (
        <ViewRxDialog
          viewRxDialogVisible={viewRxDialogVisible}
          orderId={currentOrder.orderId}
          patientName={currentOrder.patientName}
          setViewRxDialogVisibility={
            setViewRxDialogVisibility
          }
          uploadedFiles={currentOrder.uploadedFiles}
        ></ViewRxDialog>
      )}
    </>
  );
};
